// `UNLISTED` is the stored name of the tier the product calls Agent. It predates
// INTERNAL, and renaming a Postgres enum value is not worth a migration, so the
// literal stays and only the labels say Agent.
export type ArticleVisibility = "PUBLIC" | "UNLISTED" | "INTERNAL"

// Ordered least hidden to most: PUBLIC reaches the docs site, UNLISTED reaches
// the AI Agent, INTERNAL reaches the AI Assistant and nothing else.
const RANK: Record<ArticleVisibility, number> = {
	PUBLIC: 0,
	UNLISTED: 1,
	INTERNAL: 2,
}

// A row written before the column existed reads as public, which is what the
// database default says too.
export const visibilityRank = (visibility: string): number =>
	RANK[visibility as ArticleVisibility] ?? 0

// A subpage is only reachable through its parent, so a parent can never be more
// hidden than its branch. Returns the visibility a subpage has to take.
export const cascadedVisibility = (
	parent: string,
	subpage: string,
): ArticleVisibility =>
	visibilityRank(parent) > visibilityRank(subpage)
		? (parent as ArticleVisibility)
		: (subpage as ArticleVisibility)

export const needsCascade = (parent: string, subpage: string): boolean =>
	visibilityRank(parent) > visibilityRank(subpage)
